(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["final-sale"] && !Shopify.designMode) return;
  try {
    class FinalSaleNotice extends HTMLElement {
    connectedCallback() {
      this.eventScope = this.closest('.shopify-section, dialog');
      this.eventScope?.addEventListener('variant:update', this.onVariantUpdate);
    }

    disconnectedCallback() {
      this.eventScope?.removeEventListener('variant:update', this.onVariantUpdate);
    }

    /**
     * @param {CustomEvent<{ resource: { id?: string | number } | null, data: { html?: Document, productId?: string, newProduct?: { id?: string | number } } }>} event
     */
    onVariantUpdate = (event) => {
      const data = event.detail?.data;

      if (!data?.html) return;

      if (data.newProduct) {
        this.dataset.productId = String(data.newProduct.id);
      } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
        return;
      }

      const blockId = this.dataset.blockId || '';
      const productId = this.dataset.productId || '';
      const next =
        (blockId && data.html.querySelector(`final-sale-notice[data-block-id="${CSS.escape(blockId)}"]`)) ||
        (productId && data.html.querySelector(`final-sale-notice[data-product-id="${CSS.escape(productId)}"]`));

      if (!(next instanceof HTMLElement)) return;

      const currentMessage = this.querySelector('.final-sale');
      const nextMessage = next.querySelector('.final-sale');

      if (!(currentMessage instanceof HTMLElement) || !(nextMessage instanceof HTMLElement)) return;

      if (nextMessage.hasAttribute('hidden')) {
        currentMessage.setAttribute('hidden', '');
      } else {
        currentMessage.removeAttribute('hidden');
      }
    };
  }

  if (!customElements.get('final-sale-notice')) {
    customElements.define('final-sale-notice', FinalSaleNotice);
  }
  } catch(e) { console.error(e); }
})();

})();
